<template>
  <div class="flex w-full justify-center space-x-8 p-4">
    <IconBeepaidHelp />
    <IconBeepaidHelpPhone />
  </div>

  <p class="mb-8 text-center text-lg text-background-fg/87">
    Chat to us, we're here to help you!
  </p>

  <div class="px-8 py-2 text-background-fg/87">
    <button
      type="button"
      class="flex size-full items-center space-x-4 rounded-lg p-2 hover:bg-background-fg/3"
      @click="onClickPhone"
    >
      <IconHeroiconsChatBubbleLeftEllipsis />
      <div class="flex flex-col items-center">
        <p class="text-lg"> Call Support </p>
        <p class="text-base text-background-fg/50">
          {{ supportPhone }}
        </p>
      </div>
    </button>
  </div>
</template>

<script setup lang="ts">
const supportPhone = "01606566600"

const onClickPhone = () => {
  window.open(`tel:${supportPhone}`, "_self")
}
</script>
